<script lang="ts">
    import PanelistSurveyCriterionPage from '@Evaluation/CriteriaSurveys/Pages/PanelistSurveyCriterionPage'
    export default PanelistSurveyCriterionPage
</script>

<template>
    <div>
        <CriterionDetailsDialog :viewModel="criterionDetailsDialog" />

        <template v-if="initialized === false">
            <div class="container">
                <h3 class="text-center"><i class="fa fa-spinner fa-spin"></i> Loading...</h3>
            </div>
        </template>

        <div v-if="initialized === true" class="container">
            <nav class="navbar fixed-bottom navbar-dark bg-dark">
                <div class="container d-flex justify-content-center">
                    <div class="btn-group" role="group">
                        <a class="btn btn-secondary" v-sanitizedHref="rm.PrevContextUrl">
                            <i class="fa fa-angle-double-left" aria-hidden="true"></i> Prev <span class="d-none d-sm-inline">criterion</span>
                        </a>
                        <button type="button" class="btn btn-warning" @click="scrollTop">Back to Top</button>
                        <a class="btn btn-secondary" v-sanitizedHref="rm.NextContextUrl">
                            Next <span class="d-none d-sm-inline">criterion</span> <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </nav>

            <nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
                <div class="container">

                    <a class="btn btn-light mr-auto" v-sanitizedHref="rm.DashboardUrl">
                        <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                        My Survey
                    </a>

                    <div class="progress mx-2 w-50" style="height: 38px; background-color: #D3D3D3;">
                        <div class="progress-bar" role="progressbar" :style="{'width': Progress + '%'}">{{ProgressStr}}</div>
                    </div>

                    <button v-if="IsSaved == null" type="button" class="btn btn-warning" @click="handleSavePanelistCriterionVotesCommand">
                        <i class="fa fa-spinner fa-spin"></i> Saving...
                    </button>
                    <button v-if="IsSaved === true" type="button" class="btn btn-light" @click="handleSavePanelistCriterionVotesCommand">
                        Saved
                    </button>
                    <button v-if="IsSaved === false" type="button" class="btn btn-warning" @click="handleSavePanelistCriterionVotesCommand">
                        Save
                    </button>
                </div>
            </nav>

            <div style="padding-top: 80px; padding-bottom: 120px;">
                <h3 id="top" class="mt-4">
                    <span class="font-weight-light">Compare criteria in the context of:</span> {{rm.Name}}
                </h3>
                <hr />

                <nav class="navbar navbar-expand-md navbar-light bg-light">
                    <ul class="navbar-nav">
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown">
                                Questions: {{questionsFilter ?? 'All'}}
                            </a>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" @click="questionsFilter = null">All <span class="badge badge-secondary">{{QuestionsCount}}</span></a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" @click="questionsFilter = 'Answered'">Answered <span class="badge badge-secondary">{{AnsweredQuestionsCount}}</span></a>
                                <a class="dropdown-item" @click="questionsFilter = 'Not answered'">Not answered <span class="badge badge-secondary">{{NotAnsweredQuestionsCount}}</span></a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" @click="questionsFilter = 'Commented'">Commented <span class="badge badge-secondary">{{CommentedQuestionsCount}}</span></a>
                                <a class="dropdown-item" @click="questionsFilter = 'Not commented'">Not commented <span class="badge badge-secondary">{{NotCommentedQuestionsCount}}</span></a>
                            </div>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" @click="loadConsistencyAnalysis">
                                Most inconsistent
                            </a>
                            <div class="dropdown-menu">
                                <template v-if="rm.ConsistencyAnalysis == null">
                                    <p class="m-4"><i class="fa fa-spinner fa-spin"></i></p>
                                </template>
                                <template v-else>
                                    <template v-if="InsufficientData === true">
                                        <p class="px-2">Not enough answers to check consistency</p>
                                    </template>
                                    <template v-if="IsConsistent === true">
                                        <a class="dropdown-item" @click="showConsistencyAnalysisLegend">
                                            <span class="fa-stack fa-lg fa-stack-sm">
                                                <i class="fa fa-circle fa-stack-1x text-success"></i>
                                                <i class="fa-regular fa-face-smile fa-stack-1x"></i>
                                            </span>
                                            Inconsistency score: {{rm.ConsistencyAnalysis.CR}}%
                                        </a>
                                    </template>
                                    <template v-if="IsAcceptable === true">
                                        <a v-for="q in MostInconsistent" :key="q.Id" class="dropdown-item" @click="highlightQuestion(q)">
                                            {{q.Name1}} vs. {{q.Name2}}
                                        </a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" @click="showConsistencyAnalysisLegend">
                                            <span class="fa-stack fa-lg fa-stack-sm">
                                                <i class="fa fa-circle fa-stack-1x text-warning"></i>
                                                <i class="fa-regular fa-face-meh fa-stack-1x"></i>
                                            </span>
                                            Inconsistency score: {{rm.ConsistencyAnalysis.CR}}%
                                        </a>
                                    </template>
                                    <template v-if="IsInconsistent === true">
                                        <a v-for="q in MostInconsistent" :key="q.Id" class="dropdown-item" @click="highlightQuestion(q)">
                                            {{q.Name1}} vs. {{q.Name2}}
                                        </a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" @click="showConsistencyAnalysisLegend">
                                            <span class="fa-stack fa-lg fa-stack-sm">
                                                <i class="fa fa-circle fa-stack-1x text-danger"></i>
                                                <i class="fa-regular fa-face-frown fa-stack-1x"></i>
                                            </span>
                                            Inconsistency score: {{rm.ConsistencyAnalysis.CR}}%
                                        </a>
                                    </template>
                                </template>
                            </div>
                        </li>
                    </ul>
                    <form class="form-inline my-2 my-lg-0 ml-auto">
                        <input class="form-control mr-sm-2" type="search" placeholder="Filter..." v-model="searchPhrase">
                    </form>
                </nav>

                <div v-for="q in QuestionsView" :key="q.QuestionId" class="row justify-content-start" :id="getDomId(q)">
                    <div class="col-md-8 col-sm-12" :class="{'bg-warning': q.Highlighted}">
                        <p class="mt-5 mb-3 lead">
                            <strong>{{q.OrderValue}}.</strong>
                            In the context of <a class="text-dark font-italic" @click="showCriterionDetails(rm.Name, rm.Path, rm.Description)">{{rm.Name}}</a>,
                            which criterion is more important: <br />
                            <a class="text-primary" @click="showCriterionDetails(q.Name1, q.Path1, q.Description1)">{{q.Name1}}</a> or
                            <a class="text-primary" @click="showCriterionDetails(q.Name2, q.Path2, q.Description2)">{{q.Name2}}</a>?
                        </p>

                        <div>
                            <div class="btn-group-vertical d-flex" role="group">
                                <div class="btn-group" role="group">
                                    <template v-if="q.Value > 1.0">
                                        <button type="button" data-toggle="dropdown" class="btn text-left btn-primary" style="padding: 0.75rem 1.25rem;">
                                            <span class="badge badge-pill badge-light text-primary">
                                                <i class="fa fa-check" aria-hidden="true"></i>
                                                <span>{{getScaleLabel(q.Value)}}</span>
                                            </span>
                                            <span>{{q.Name1}}</span>
                                        </button>
                                        <div class="dropdown-menu">
                                            <h4 class="dropdown-header">How much more important?</h4>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 2)">Weak</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 3)">Moderate</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 4)">Moderate +</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 5)">Strong</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 6)">Strong +</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 7)">Very strong</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 8)">Very strong +</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 9)">Extreme</a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="SetValueCommand(q, null)">
                                                <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                                Clear
                                            </a>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <button type="button" data-toggle="dropdown" class="btn text-left btn-outline-secondary" style="padding: 0.75rem 1.25rem;">
                                            <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                            <span>{{q.Name1}}</span>
                                        </button>
                                        <div class="dropdown-menu">
                                            <h4 class="dropdown-header">How much more important?</h4>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 2)">Weak</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 3)">Moderate</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 4)">Moderate +</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 5)">Strong</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 6)">Strong +</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 7)">Very strong</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 8)">Very strong +</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 9)">Extreme</a>
                                        </div>
                                    </template>
                                </div>

                                <template v-if="q.Value === 1.0">
                                    <button type="button" class="btn btn-primary text-left" @click="SetValueCommand(q, null)" style="padding: 0.75rem 1.25rem;">
                                        <i class="fa fa-check-circle"></i> Equally important
                                    </button>
                                </template>
                                <template v-else>
                                    <button type="button" class="btn btn-outline-secondary text-left" @click="SetValueCommand(q, 1.0)" style="padding: 0.75rem 1.25rem;">
                                        <i class="fa fa-circle-thin"></i> Equally important
                                    </button>
                                </template>

                                <div class="btn-group" role="group">
                                    <template v-if="q.Value != null && q.Value < 1.0">
                                        <button type="button" class="btn btn-primary text-left" data-toggle="dropdown" style="padding: 0.75rem 1.25rem;">
                                            <span class="badge badge-pill badge-light text-primary">
                                                <i class="fa fa-check" aria-hidden="true"></i>
                                                <span>{{getScaleLabel(q.Value)}}</span>
                                            </span>
                                            <span>{{q.Name2}}</span>
                                        </button>
                                        <div class="dropdown-menu">
                                            <h4 class="dropdown-header">How much more important?</h4>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/2.0)">Weak</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/3.0)">Moderate</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/4.0)">Moderate +</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/5.0)">Strong</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/6.0)">Strong +</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/7.0)">Very strong</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/8.0)">Very strong +</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/9.0)">Extreme</a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="SetValueCommand(q, null)">
                                                <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                                Clear
                                            </a>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <button type="button" class="btn btn-outline-secondary text-left" data-toggle="dropdown" style="padding: 0.75rem 1.25rem;">
                                            <i class="fa fa-circle-thin" aria-hidden="true"></i>
                                            <span>{{q.Name2}}</span>
                                        </button>
                                        <div class="dropdown-menu">
                                            <h4 class="dropdown-header">How much more important?</h4>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/2.0)">Weak</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/3.0)">Moderate</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/4.0)">Moderate +</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/5.0)">Strong</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/6.0)">Strong +</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/7.0)">Very strong</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/8.0)">Very strong +</a>
                                            <a class="dropdown-item" @click="SetValueCommand(q, 1.0/9.0)">Extreme</a>
                                        </div>
                                    </template>


                                </div>
                            </div>

                            <textarea rows="3" :value.trim="q.Comment" @input="setComment($event.target.value, q)" class="form-control my-3" placeholder="Comment..."></textarea>

                            <!--<textarea rows="3" v-model.trim="q.Comment" class="form-control my-3" placeholder="Comment..."></textarea>-->
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
